export const guessExtension = (fileSource: string) => {
  const lastDot = fileSource.lastIndexOf('.');
  return lastDot !== -1 ? fileSource.slice(lastDot + 1) : null;
};
